import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col lg={4} className="mb-4">
            <h5>Allied Thermal</h5>
            <p>Leading provider of thermal engineering solutions for industrial and commercial applications worldwide.</p>
            <div className="mt-3">
              <strong>Certified & Compliant</strong><br />
              <small>ISO 9001:2015 | ISO 14001:2015</small>
            </div>
          </Col>
          <Col lg={2} className="mb-4">
            <h6>Quick Links</h6>
            <div>
              <Link to="/" className="d-block mb-2">Home</Link>
              <Link to="/services" className="d-block mb-2">Services</Link>
              <Link to="/products" className="d-block mb-2">Products</Link>
              <Link to="/company-profile" className="d-block mb-2">Company Profile</Link>
              <Link to="/contact-us" className="d-block mb-2">Contact Us</Link>
            </div>
          </Col>
          <Col lg={3} className="mb-4">
            <h6>Services</h6>
            <div>
              <span className="d-block mb-2">Thermal System Design</span>
              <span className="d-block mb-2">Installation & Commissioning</span>
              <span className="d-block mb-2">Maintenance & Support</span>
              <span className="d-block mb-2">Performance Optimization</span>
            </div>
          </Col>
          <Col lg={3} className="mb-4">
            <h6>Contact Info</h6>
            <div className="contact-item">📞 +91 9312068097</div>
            <div className="contact-item">✉️ alliedthermaldlf@gmail.com</div>
            <div className="contact-item">📍 Block-A, Plot-1731, NHPC Rd, Faridabad, Haryana</div>
            <div className="contact-item">💬 <a href="https://wa.me/919312068097" target="_blank" rel="noopener noreferrer" style={{color: '#25d366'}}>WhatsApp Support</a></div>
          </Col>
        </Row>
        <hr className="my-4" />
        <Row>
          <Col md={6}>
            <p>&copy; 2024 Allied Thermal Corporation. All rights reserved.</p>
          </Col>
          <Col md={6} className="text-md-end">
            <span className="me-3">Privacy Policy</span>
            <span className="me-3">Terms of Service</span>
            <span>Site Map</span>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
